var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5073 3.88606C56.2878 3.70752 56.029 3.58362 55.7522 3.52454C55.4755 3.46545 55.1886 3.47288 54.9153 3.5462L37.7252 8.91251L20.4993 0.165418C20.2639 0.0564445 20.0075 0 19.7481 0C19.4886 0 19.2322 0.0564445 18.9968 0.165418L1.10906 7.48149C0.779578 7.61685 0.498008 7.84749 0.300424 8.14386C0.102839 8.44024 -0.00176154 8.78886 2.24448e-05 9.14505V45.7791C0.00148186 46.0721 0.0748796 46.3602 0.213765 46.6182C0.35265 46.8761 0.552771 47.096 0.79654 47.2585C1.04031 47.4211 1.32026 47.5212 1.6118 47.5502C1.90334 47.5792 2.19753 47.5361 2.46853 47.4248L19.6765 40.3591L36.8308 49.1599C37.0854 49.2903 37.3676 49.3578 37.6537 49.3566C37.8315 49.3836 38.0124 49.3836 38.1903 49.3566L56.078 43.7757C56.4549 43.6576 56.7822 43.4181 57.0087 43.0945C57.2352 42.7709 57.3482 42.3815 57.3302 41.9869V5.33497C57.3209 5.04482 57.2411 4.76129 57.0978 4.50886C56.9544 4.25643 56.7518 4.04268 56.5073 3.88606ZM53.6632 40.6632L38.7806 45.314V41.2177H35.9186V44.7953L20.8929 37.0857V34.0626H18.0308V37.1393L3.57757 43.0959V10.3256L18.0308 4.36903V8.57265H20.8929V4.38692L35.9186 12.0786V15.8351H38.7806V12.4901L53.6632 7.7677V40.6632Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9219 19.7524H38.7839V26.5677H35.9219V19.7524Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9219 30.4851H38.7839V37.3003H35.9219V30.4851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0312 12.5973H20.8933V19.4125H18.0312V12.5973Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0312 23.4552H20.8933V30.1631H18.0312V23.4552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoards);
export default __webpack_public_path__ + "static/media/boards.c3159da27dbd9900a126043aeb9d14da.svg";
export { ForwardRef as ReactComponent };